import { createTooltipItems } from "../tooltips/highchartTooltip";
import { getLineData, getScattersData, getSeries } from "./helper";
import { SeriesType } from "./types";
import { nullableNumber } from "common/number-helper";
import { VisitNodePassage } from "hooks/widget-data/datapoints-api/types";
const init = (context) => {
    if (!context.staticData.customResult?.length) {
        context.staticData.customResult = [
            {
                hasColorDimension: false,
                hasData: false,
                items: [],
                series: []
            }
        ];
    }
};
export const addScatterPlotItem = (params, element, result) => {
    const item = {
        dataX: nullableNumber(element.measures?.[params.dataX]),
        dataY: nullableNumber(element.measures?.[params.dataY])
    };
    if (params.dataColor) {
        item.dataColor = (element.measures?.[params.dataColor] || "").toString();
    }
    if (params.tooltipItems?.length) {
        item.tooltips = createTooltipItems(params.tooltipItems, element.measures);
    }
    result.items.push(item);
};
export const setLineAndScatterSeries = (componentProps, result) => {
    const { colorSet, displayLinearRegression } = componentProps || {}, [scattersData, hasColorDimension] = getScattersData(result.items, colorSet, displayLinearRegression), lineData = getLineData(result.items, displayLinearRegression);
    result.hasColorDimension = hasColorDimension;
    if (lineData) {
        result.lineData = lineData;
    }
    const data = [...scattersData, lineData].filter((x) => x !== null);
    result.hasData = data.some((s) => s.type === SeriesType.Scatter && s.data && s.data.length > 0);
    result.series = getSeries(data, colorSet);
};
export const scatterPlot = (params) => (args) => {
    if (args.context.visitNodePassage === VisitNodePassage.NodeFirst && args.visitable) {
        init(args.context);
    }
    const [result] = args.context.staticData.customResult || [];
    if (args.context.visitNodePassage === VisitNodePassage.Leaf && args.visitable && result) {
        addScatterPlotItem(params, args.visitable, result);
    }
    if (args.context.visitNodePassage === VisitNodePassage.NodeLast && args.context.componentProps && result) {
        setLineAndScatterSeries(args.context.componentProps, result);
    }
};
